import { Alert, Button, CircularProgress, Dialog, DialogContent } from "@mui/material";
import Cookies from "js-cookie";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import axiosInstance from "../../../../../../axios";


const ActiveEmail = ({emailRef}) => {
    const {t, i18n } = useTranslation();
    const [activeEmail, setActiveEmail] = useState(false);
    const [Progress, setProgress] = useState(false);
    const email = localStorage.getItem('email');
    const emailActive = localStorage.getItem("emailActive");
    const closeDialog = () => {
        setActiveEmail(false);
    }
    const handleActiveEmail = async() => {
        setProgress(true);
        try {
            const lastN = localStorage.getItem('lastname');
           const tempData = {
                email: email,
                firstName: localStorage.getItem('name'),
                // lastName: localStorage.getItem('lastname'),
                lastName: lastN? lastN: ' ',
                "organization_id": parseInt(Cookies.get("organization"))
              }
            const response = await axiosInstance.post(`${process.env.REACT_APP_ENDPOINT}/send-activation-email`,tempData);
            setActiveEmail('success');
        } catch (error) {
            console.error(error);
            setActiveEmail('error');

        } finally {
            setProgress(false);
        }

    }
    return (
        <div>
            <Dialog className="sm:ms-56" open={activeEmail} onClose={closeDialog}>
                {Progress && (
                    <div className="absolute inset-0 flex justify-center items-center bg-gray-50 bg-opacity-75 z-50">
                        <CircularProgress className="text-blue-800" />
                    </div>
                )}
                <DialogContent>
                    {activeEmail === 'active' ?
                        (<p>{t('Settings.ActivateMsg')}</p>) : (
                            <Alert severity={activeEmail ? activeEmail :''}>{activeEmail === 'success' ? `${t('Settings.WeSentYou')} ${email} ${t('Settings.CheckConfirm')}` : `${t('Onboarding.ErrorOccurred')}`}</Alert>
                        )}
                    {/* Action buttons */}
                    {activeEmail === 'active' ?
                        (<div className="flex justify-center mt-3">
                            <Button onClick={handleActiveEmail}><p>{t('Settings.ActivateNow')}</p></Button>
                            <Button onClick={closeDialog}><p>{t('Settings.Later')}</p></Button>
                        </div>) : (
                            <div className="flex justify-center mt-3">
                                {activeEmail === 'success' &&<Button onClick={closeDialog}><Link target="_blank" to='https://mail.google.com/mail/'><p>{t('Settings.CheckMail')}</p></Link></Button>}
                                <Button onClick={closeDialog}><p>{t('Settings.Okay')}</p></Button>
                            </div>)}
                </DialogContent>

            </Dialog>
            <div className="text-center">
                <button ref={emailRef} disabled={emailActive}
                    onClick={() => setActiveEmail('active')}
                    className={`relative overflow-hidden group rounded-[10px] ${emailActive?'px-2':'hover:text-white hover:scale-110 w-56 px-5'}  bg-[#DBE6F5]  transition-all duration-300 ease-in-out font-bold py-3 shadow-md`}>
                        {!emailActive && <span className={`absolute inset-0 bg-[#7688A1] ${i18n.language==='ar'?'-translate-x-full':'translate-x-full'} -translate-y-full  group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500 animate-pulse`}></span>}
                        <span className="relative">{emailActive ?t('Settings.Activated'):t('Settings.ActivateYourEmail')}</span>
                        </button>
            </div>
        </div>
    )
};
export default ActiveEmail;